import { renderSlot as _renderSlot, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-b2fe83b6"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "tw-flex tw-flex-row tw-items-center"
}
const _hoisted_2 = { class: "tw-m-0" }
const _hoisted_3 = {
  key: 1,
  class: "custom-global-skeleton tw-bg-[#ffffff] tw-min-w-[60px] tw-h-[20px] tw-w-[100%]"
}
const _hoisted_4 = { class: "tw-flex-1" }
const _hoisted_5 = ["id", "value", "data-cy", "type", "name", "placeholder", "required"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _renderSlot(_ctx.$slots, "icon", {}, undefined, true),
    (_ctx.isModal)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", {
            class: _normalizeClass([
        'tw-text-[#B7B7B7] tw-text-[11px] tw-p-[6px] tw-pl-[9px]  assessment-tag ' +
          (!_ctx.isFocus && !_ctx.value && !_ctx.isHover ? 'is-out-focus-input' : ''),
      ])
          }, [
            _createElementVNode("span", null, _toDisplayString(_ctx.getUiText("app-component-assessments-search-box-assessment-tag-2")), 1)
          ], 2),
          (_ctx.activeCategoryName)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: _normalizeClass([
        'tw-flex-initial tw-items-center tw-px-[5px] tw-py-[3px] tw-text-[11px] tw-text-[#387DFF] tw-bg-[#F2F8FF] tw-font-medium tw-rounded-[6px] assessment-tag ' +
          (!_ctx.isFocus && !_ctx.value && !_ctx.isHover ? 'is-out-focus-input' : ''),
      ])
              }, [
                _createElementVNode("p", _hoisted_2, _toDisplayString(_ctx.activeCategoryName
            ? _ctx.activeCategoryName
            : _ctx.getUiText("app-component-assessments-search-box-assessment-tag-1")), 1)
              ], 2))
            : (_openBlock(), _createElementBlock("div", _hoisted_3))
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("input", {
        id: _ctx.id,
        ref: "searchInput",
        value: _ctx.value,
        "data-cy": _ctx.dataCy,
        type: _ctx.type,
        name: _ctx.name,
        placeholder: _ctx.placeholder,
        required: _ctx.required,
        class: _normalizeClass(`tw-flex tw-w-full tw-items-start ${_ctx.classStyle} ${
        _ctx.hasError ? 'tw-border-red-500 tw-text-[red]' : ''
      }`),
        onInput: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.updateValueInput && _ctx.updateValueInput(...args))),
        onBlur: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onBlur && _ctx.onBlur(...args))),
        onFocus: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.onFocus && _ctx.onFocus(...args))),
        onKeypress: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.onEnter && _ctx.onEnter(...args)))
      }, null, 42, _hoisted_5)
    ])
  ], 64))
}